import { storage } from 'APP/packages/storage';
import Entities from 'STORE';

export function setCustomChatBackground(url: string): string | null {
  const userId = Entities.usersStore.myId;
  if (!userId) {
    return null;
  }
  const ts = Date.now();

  storage.chatBackgroundsCustom.set(ts, url, userId);
  Entities.appearance.addCustomChatBackground(String(ts), {
    id: String(ts),
    url,
    timestamp: ts,
  });

  return String(ts);
}
